export class PatientAccModel {
w_type = '' ;
w_serial = '' ;
w_amount = 0 ;
w_date = '2022-01-01' ;
w_patient = '' ;
w_desc = 0 ;
w_net = 0;
st_bank = '' ;
}
